module.exports = __webpack_public_path__ + "img/SSLRECN.b644671a.svg";